import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=23f91a34&"
import script from "./sort.vue?vue&type=script&lang=js&"
export * from "./sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23f91a34')) {
      api.createRecord('23f91a34', component.options)
    } else {
      api.reload('23f91a34', component.options)
    }
    module.hot.accept("./sort.vue?vue&type=template&id=23f91a34&", function () {
      api.rerender('23f91a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/sort.vue"
export default component.exports